// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"126":"8eb5cbd8","9427":"8e3e0f30"}[chunkId] + ".css";
};